import { Controller } from "@hotwired/stimulus"
import Autocomplete from "bootstrap5-autocomplete"

// Package delivery form autocomplete controller
// Connects to data-controller="package-delivery-autocomplete"
// Expects data-package-delivery-autocomplete-url-value as the base server URL
export default class extends Controller {
  static values = { url: String }

  connect() {
    this._autocomplete = new Autocomplete(this.element, {
      server: this.urlValue,
      liveServer: true,
      queryParam: "term",
      minimumCharacters: 1,
      suggestionsThreshold: 1,
      maximumItems: 10,
      noCache: false,
      debounceTime: 200,
      onSelectItem: (item) => {
        this.element.value = item.label
      }
    })
  }

  disconnect() {
    if (this._autocomplete) {
      this._autocomplete.dispose()
      this._autocomplete = null
    }
  }
}
